import Vue from 'vue';
import {EventBus} from  '../../lib/EventBus';

export default {
    /**
     * This is the place we transition between nodes so any logic needed to "reset" the player can be handled here
     * setActive node is the start of the transition state between previous and next video setActiveNode
     * */
    startTransition({ commit, getters, dispatch }, nodeId) {
        // console.log('start transition called')
        // ⚡️update time here is for split second bug, interaction show up in incoming node
        commit('pause');
        commit('setBuffering', true);
        commit('setNextNode', nodeId);

        try {
            const node = getters.nodes[nodeId];

            if (!node) throw 'Node not found';

            const video = getters.videos[node.media_id];

            if (!video) throw 'Video not found';

            /* should Load again only if not already in  videoQueue ,
            Also trigger endTransition from here too because it normally triggers
            when the incomming video is mounted and hls loaded, which won't be happening 
            in this case */
            if (getters.videoQueue && getters.videoQueue[video.id]) {
                dispatch('endTransition', video.id);
            } else {
                commit('loadVideo', {
                    id: video.id,
                    zIndex: getters.currentZIndex - 1
                });
            }
        } catch (err) {
            console.error(err);
        }
    },

    /**
     * This is the end of the transition between the old and new video
     */
    endTransition({ commit, getters }, videoId) {
        const previousVideo = getters.activeVideoId;
        // Check incomming video is different the current one , Nodes can have same video
        const isNewVideo = previousVideo != videoId;
        // console.log('end transition is called with video id ', {videoId, isNewVideo, previousVideo} )
        /** Set the node and  Video as Ready and reset state tracked time for interactions to not show while switching video */
        commit('updateCurrentTime', 0)
        commit('setActiveNode', getters.next);
        /* if it's the same video as previous one we're not reloading anything just replaying with skip event, look below 👇 */
        if (isNewVideo) commit('setVideoReady', videoId);

        /** Remove the buffering UI  */
        commit('setBuffering', false);

        /** If it's the first video it won't have a previous video and shouldn't play from here*/
        if (!previousVideo) return;

        // restart the video from scratch if it's the same video as previous one
        if(!isNewVideo) EventBus.$emit('skipTo', 0);
        commit('play');

        /** Next video is ready so we can remove the previous video and reset the next node */
        /** only remove it if its a different video */
        if (isNewVideo) commit('removeVideoFromQueue', previousVideo);
        commit('setNextNode', 0);
    }
};
